export interface sfMyShelf {
  Id: string
  Contact__c: string
  CreatedById: string
  CreatedDate: string
  IsDeleted: boolean
  LastModifiedById: string
  LastModifiedDate: string
  LastReferencedDate: string
  LastViewedDate: string
  Name: string
  OwnerId: string
  Resource__r: {
    Name: string
    Number__c: string
    Id: string
  }
  Resource__c: string
  SystemModstamp: string
}

export interface MyShelf {
  id: string
  contact: string
  createdBy: string
  createdDate: string
  isDeleted: boolean
  lastModifiedBy: string
  lastModifiedDate: string
  lastReferencedDate: string
  lastViewedDate: string
  name: string
  ownerId: string
  resource: {
    id: string
    name: string
    number: string
  }
  resourceId: string
  systemModstamp: string
}

export const myShelfMapFields = {
  direction: 'in',
  Id: 'id',
  Contact__c: 'contact',
  CreatedById: 'createdBy',
  CreatedDate: 'createdDate',
  IsDeleted: 'isDeleted',
  LastModifiedById: 'lastModifiedBy',
  LastModifiedDate: 'lastModifiedDate',
  LastReferencedDate: 'lastReferencedDate',
  LastViewedDate: 'lastViewedDate',
  Name: 'name',
  OwnerId: 'ownerId',
  Resource__c: 'resourceId',
  Resource__r: {
    key: 'resource',
    in: (obj: sfMyShelf) => {
      return {
        id: obj.Resource__r.Id,
        name: obj.Resource__r.Name,
        number: obj.Resource__r.Number__c
      }
    }
  },
  SystemModstamp: 'systemModstamp'
}
